<template>
  <div class="about-us-goal bg--color-01">
    <div class="container-wrapper bg--color-08">
      <div class="about-us-goal__container container-new">
        <img
          class="about-us-goal__image"
          width="100%"
          src="@/assets/img/about-us/goal/main.svg"
          alt="cup image"
        >

        <div class="about-us-goal__info">
          <h4
            class="txt--bold txt--36px txt--44px--l txt--height-44px txt--height-60px--l txt--color-04 mb-16 mb-24--l"
          >
            {{ $t('aboutUs.goalBlock.title') }}
          </h4>

          <p
            class="txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-04 mb-0"
          >
            {{ $t('aboutUs.goalBlock.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUsGoal',
}
</script>

<style lang="scss" scoped>
.about-us-goal {
  &__container {
    display: grid;
    gap: toRem(16px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include bp(l) {
      gap: toRem(20px);
    }
  }

  &__image {
    max-width: toRem(237px);

    @include bp(m) {
      max-width: toRem(420px);
    }
  }

  &__info {
    @include bp(m) {
      margin: auto 0;
    }
  }
}
</style>
